import { render, staticRenderFns } from "./ClaimContactInfo.vue?vue&type=template&id=57382418"
import script from "./ClaimContactInfo.vue?vue&type=script&lang=ts"
export * from "./ClaimContactInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports